<template>
  <div class="wallet-form__quick" :class="rootClass">
    <button
      v-for="item in quickAmounts"
      :key="item.amount"
      type="button"
      @click="$emit('add', item.amount)"
    >{{ item.label }}</button>
    <button type="button" class="wallet-form__quick-reset" @click="$emit('reset')">{{ $t('wallet.reset') }}</button>
  </div>
</template>

<script>
import { getWalletQuickAmounts } from '@/utils/wallet'

export default {
  name: 'WalletQuickAmountButtons',

  props: {
    rootClass: {
      type: [String, Object, Array],
      default: ''
    }
  },

  computed: {
    quickAmounts () {
      return getWalletQuickAmounts()
    }
  }
}
</script>
